/* istanbul ignore file */

export default {
  "privacy-policy": "https://www.vodafone.gr/vodafone-ellados/privacy-policy-cookies",
  "help-and-support": "https://www.vodafone.gr/ypostirixi/faqs/disney-plus",
  "terms-and-conditions":
    "https://www.vodafone.co.uk/terms-and-conditions/consumer/mobile/pay-monthly/entertainment/Vodafone-entertainment/",
  "cookie-preferences": "cookie-preferences",
  accessibility: "accessibility",
};
